module.exports = __webpack_public_path__ + "img/IMG_0105.876a008b.jpeg";